import {
  Download1Stroke,
  Pencil1Stroke,
  PlusStroke,
  RefreshCircle1ClockwiseStroke,
  SignPostLeftStroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';
import { downloadTemplate } from '../utils/excel-util';
interface ActionBarProps {
  onAddClick: () => void;
  onEditClick: () => void;
  onDeleteClick: () => void;
  onCopyClick: () => void;
  onRefreshClick: () => void;
  onShowSidebar?: () => void;
  onImportFromExcel?: () => void;
}

export const ActionBar = ({
  onAddClick,
  onEditClick,
  onDeleteClick,
  onCopyClick,
  onRefreshClick,
  onShowSidebar,
  onImportFromExcel
}: ActionBarProps) => {
  return (
    <ActionBarV2 title='Danh mục khách hàng' className='flex w-full min-w-0 items-center justify-between bg-white p-4'>
      <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAddClick} variant='primary' />
      <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEditClick} />
      <ActionButtonV2 icon={Trash3Stroke} title='Xóa' onClick={onDeleteClick} />
      <ActionButtonV2 icon={Download1Stroke} title='Sao chép' onClick={onCopyClick} />
      <ActionButtonV2 icon={RefreshCircle1ClockwiseStroke} title='Refresh' onClick={onRefreshClick} />
      <ActionButtonV2 icon={SignPostLeftStroke} title='Cố định cột' onClick={() => {}} />
      <MenuButtonV2
        items={[
          {
            title: 'Cập nhật trạng thái doanh nghiệp',
            icon: <AritoIcon icon={15} />,
            onClick: () => {},
            group: 0
          },
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={18} />,
            onClick: () => {},
            group: 0
          },
          {
            title: 'Tải mẫu Excel',
            icon: <AritoIcon icon={28} />,
            onClick: () => {
              downloadTemplate();
            },
            group: 1
          },
          {
            title: 'Lấy dữ liệu từ Excel',
            icon: <AritoIcon icon={29} />,
            onClick: onImportFromExcel || (() => {}),
            group: 1
          },
          {
            title: 'Phân nhóm nhiều khách hàng',
            icon: <AritoIcon icon={774} />,
            onClick: () => {},
            group: 2
          },
          {
            title: 'Ẩn/hiện cây phân nhóm',
            icon: <AritoIcon icon={538} />,
            onClick: onShowSidebar,
            group: 2
          }
        ]}
      />
    </ActionBarV2>
  );
};
